import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import SongOptions from './song-options';

@inject('songsStore', 'artistStore')
@observer
class SongRow extends Component {
	
	render () {
		const {
			songID,
			song,
			active,
			songsStore,
			artistStore
		} = this.props;
		
		artistStore.fetchIfEmpty();
		if (artistStore.isLoading || songsStore.isLoading) {

			return (<h4>Loading...</h4>);
		}

		const artist = artistStore.getItemByID(song._artistID);

		const classList = [
			'grid-x',
			'align-justify',
			'align-middle',
			'song-row'
		];

		if (songID === songsStore.activeSongRowID) {

			classList.push('active');
		}

		return (
			<div className={ classList.join(' ') }>
				
				<div className="cell auto">
					<div className="song-row-counter" data-full-preview-position={ song._fullPreviewPosition }>
					<span className="icon far fa-play-circle" onClick={ this.onPlayClick }></span>
					</div>
				</div>

				<div className="cell small-4">
					<div
						className="inline"
						onBlur={ this.onEditableBlur }
						ref={ (node) => this.songTitleRef = node }
					>
						{ song.title }
					</div>
				</div>

				<div className="cell small-3">
					<span>{ artist._name }</span>
				</div>

				<div className="cell small-2">
					<span>{ artist.genre.label }</span>
				</div>

				<div className="cell small-1 text-center">
					{song.duration}
				</div>

			</div>
		);
	}

	@autobind
	renderUserOpts () {
		const { songID, songsStore, optionsTheme, onBlur } = this.props;
		const song = songsStore.getSongByID(songID);
		return (
			<Fragment>
				<SongOptions
					songID={ songID }
					song={ song }
					optionsTheme={ 'light' }
					onBlur={ onBlur }
				/>
			</Fragment>
		)
	}

	@autobind
	onPlayClick () {
		const { songID, songsStore } = this.props;
		songsStore.setCurrentSong(songID);
	}

	@autobind
	onCheckboxChange ({ target: { checked } }) {
		this.props.song.explicit = checked;
	}

	@autobind
	onEditableBlur ({ target: { innerHTML: title } }) {
		this.props.song.title = title;
	}
}

export default SongRow;
